import UniversalRouter from 'universal-router';

import config from './config';
import routes from './routes';

export default new UniversalRouter(routes, {
  baseUrl: config.dir,
  resolveRoute(context, params) {
    if (typeof context.route.load === 'function') {
      return context.route.load().then(action => action.default(context, params));
    }
    if (typeof context.route.action === 'function') {
      return context.route.action(context, params);
    }
    return undefined;
  },
});
